














































































































import { MemberApi } from "@/api/admin";
import { FcmTokenApi } from "@/api/admin";
import { PaginationModel } from "@/api/types";
import CustomTable from "@/components/table.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
    components: {
      CustomTable,
    },
  })
  export default class AppPush extends Vue {

    render = false;
    tabListNoTitle = [
        {
          key: 'article',
          tab: '개인푸시',
        },

      ];
    key = "tab1";
    noTitleKey = 'article';
    searchMemberList:any = [];
    selectedRowMemberKeys:any = [];
    messageData = {
        title:"",
        content:"",
    }

    pagination: PaginationModel & { total?: number } = {
        current: 1,
        pageSize: 10,
        keyword: "",
        keywordType: "namephone",
    };

    mounted() {
        this.getMemberList();
    }

    moveOn(page: any) {
        this.pagination = page;
        this.getMemberList();
    }
    
    rowClick(record: any) {
        if(this.selectedRowMemberKeys.some((e:any) => e.code == record.code)){
            this.selectedRowMemberKeys.forEach((item:any, index:any)=> {
                if(item.code === record.code) {
                    this.selectedRowMemberKeys.splice(index, 1);
                }
            });
        }else{
            this.selectedRowMemberKeys.push(record);
        }
        
        console.log(this.selectedRowMemberKeys);
        this.$forceUpdate();
        this.render = !this.render;
    //   this.$router.push({ name: "memberDetail", query: { id: record.code , activeKey:"1"} });
    }

    rowRemoveClick(record:any){
        this.selectedRowMemberKeys.forEach((item:any, index:any)=> {
            if(item.code === record.code) {
                this.selectedRowMemberKeys.splice(index, 1);
            }
        })
        this.$forceUpdate();
        this.render = !this.render;
    }

    onTabChange(key:any, type:any) {
      console.log(key, type);
      this.selectedRowMemberKeys = [];
      this.noTitleKey = key;
    };

    // onSelectChange(selectedRowKeys: any, selectedRows: any) {
    //   console.log('selectedRowKeys changed: ', selectedRowKeys);
    //   console.log('selectedRow', selectedRows);
    //   this.selectedRowMemberKeys = selectedRowKeys;
    // };

    funcCheck(row:any) {
        return this.selectedRowMemberKeys.some((e:any) => e.code == row.code);
    }

    async sendMessage() {
        let param = {
            notification: { title : this.messageData.title, body: this.messageData.content},
            code: this.selectedRowMemberKeys.map((row: { code: any; })=>row.code),
        };
        if(window.confirm("푸시알람을 전송합니다.")){
            console.log("22");
            let response = await FcmTokenApi.send(param);
            console.log(response);
            if(response.successCount > 0){
                alert("전송을 완료했습니다.");
            }
        }
        // if (window.confirm("푸시알람을 전송합니다.")) {

        // }else {
            
        // }
    }

    // memberRowSelection = {
    //     onChange: (selectedRowKeys:any, selectedRows:any) => {
    //         console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    //     },
    //     onSelect: (record:any, selected:any, selectedRows:any) => {
    //         console.log(record, selected, selectedRows);
    //     },
    //     onSelectAll: (selected:any, selectedRows:any, changeRows:any) => {
    //         console.log(selected, selectedRows, changeRows);
    //     },
    // };

    async getMemberList() {
        
        let result = await MemberApi.list(this.pagination);
        for(let i=0; i<result.data.length; i++){
            result.data[i]['key'] = this.pagination?.current!.toString() +  i;
        }
        this.searchMemberList = [...result.data];
        this.pagination.total = result.totalCount;
        // let result: any;
        // if (this.adminMode) {
        // result = await AdminApi.list(this.pagination);
        // } else {
        // result = await MemberApi.list(this.pagination);
        // }
        // this.data = [...result.data];
        // this.pagination.total = result.totalCount;
    }

    selectedMemberColumns = [
    // {
    //         width: 150,
    //         title: "선택",
    //         align: "center",
    //         dataIndex: "chk",
    //         scopedSlots: { customRender: "chk" },
    //     },
        {
        width: 150,
        title: "이름",
        align: "center",
        dataIndex: "name",
        },
        {
        width: 200,
        align: "center",
        title: "전화번호",
        dataIndex: "phone",
        scopedSlots: { customRender: "phone" },
        },
    ]


    memberColumns = [

        {
            width: 150,
            title: "선택",
            align: "center",
            dataIndex: "chk",
            scopedSlots: { customRender: "chk" },
        },
        {
        width: 150,
        title: "이름",
        align: "center",
        dataIndex: "name",
        },
        {
        width: 200,
        align: "center",
        title: "전화번호",
        dataIndex: "phone",
        scopedSlots: { customRender: "phone" },
        },
        {
        width: 200,
        align: "center",
        title: "푸시 가능여부",
        dataIndex: "fcmToken",
        scopedSlots: { customRender: "fcmToken" },
        },
    
    ];

  }
  